var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: ['status-icon', _vm.icon]
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ace6cf"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/statusIcon.vue
// module id = null
// module chunks = 